import React from 'react';

export default function Card({ children, style, ...props }) {
  return (
    <div
      style={{
        background: 'var(--white)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        padding: 24,
        transition: 'box-shadow 0.2s',
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}